import { Component, OnInit, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { ApiService } from '../../../../services/api.service';

@Component({
  selector: 'app-elimina-ticket-backoffice',
  templateUrl: './elimina-ticket-backoffice.component.html',
  styleUrls: ['./elimina-ticket-backoffice.component.css']
})
export class EliminaTicketBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService) { }

  loading: boolean = false;  

  readonly #modal = inject(NzModalRef)
  readonly nzModalData = inject(NZ_MODAL_DATA);

  ngOnInit(): void {        
  }

  onElimina() {
    this.loading = true;

    // Elimino il ticket
    this.apiService.deleteTicket(this.nzModalData.id_ticket!).subscribe({
      next: (data) => this.apiService.setTickets(),
      error: (err) => {
        this.loading = false;
        this.apiService.error(err.error.message);
      }, complete: () => {
        this.loading = false;
        this.#modal.destroy(true);
      }
    })

  }
  
  onClose() {
    this.#modal.destroy();
  }
}
